import { FC, ReactNode } from "react";
import { LifecycleDialog as SharedLifecycleDialog } from "../../../../../../components/lifecycle/lifecycleDialog";
import { ProgressOverride } from "../../../../../../components/lifecycle/progressOverride";
import { counterpartyAttachmentApi } from "../../counterpartyAttachmentApi";

type FooterActions = {
  onClose: () => void;
  onSave: () => void;
  onComplete: () => void;
  canComplete: boolean;
  isSaving?: boolean;
};

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  fullWidth?: boolean;
  headerContent?: ReactNode;
  children: ReactNode;
  actions: FooterActions;
  progressOverride?: ProgressOverride;
};

// Thin wrapper that binds the shared lifecycle dialog to the counterparty attachment API.
export const LifecycleDialog: FC<Props> = (props) => (
  <SharedLifecycleDialog {...props} attachmentApi={counterpartyAttachmentApi} />
);
